export const cmsConfig = {
  productDetail: {
    properties: {
      battery: '4cBpPg4DgqapeE4MrQCDYY',
      responsibility: '7owBz4Wz06UnBdE0q8Wz8Z',
      bluesign: '6x4NMaflT1e1I52CXKUNeV',
      cross: '3KZNB6qGOcBRhc4LyHgmhJ',
      fly: '5eO4m0s3OHIB1zCW5RZJDF',
      manualBottle: '2ejkt4tGGGJhOwdQbwuGHH',
      manualSportDrinkingBottle: '2ejkt4tGGGJhOwdQbwuGHH',
    },
    after: 'mZ4Hdcv0buChFFNZw1q3p',
  },
  taxAndShippingContent: 'uTDIOhHJdb3wD4qYq26NZ',
  constantProductDetailAfter: 'mZ4Hdcv0buChFFNZw1q3p',
  stockAlert: {
    stockAlertAvailability: '6kerZOYh4XlJKkOWTQUfVZ',
    stockAlertStoreContent: '5mb0UWTVPPjSEqiPUcBnoX',
  },
  shippingInfo: {
    deliveryTime: '1smxReQK2eUDWtkq14OI2L',
    delivery: '3aOlcVIbYnL0NIZBnwnfff',
  },
  header: {
    navigation: '7KJolhHfheviueQ3dz1ryD',
    storefinder: '3TlujB99z0TmcEu7sstRvc',
  },
  footer: {
    legal: '5tfihH0Vc0yZ8wfUOvhm1K',
    contact: '2cE5ZXuD5CWqFLtVhJQK0k',
    navigationListDownloads: '6eD5HaV7PlXtlyOh7u8GF2',
    navigationListService: '3RXODt54nNKQwjwbTl5td9',
    navigationListInfo: '1JqSlwZZ5iJBe4VyN4KnVF',
    navigationListCompany: '7gnFNDsjL8RBeWaw5KsYNQ',
    payments: '5hOur0QbyFN0gJO1L7ET5D',
    shipping: '1GcPaK4qqHaj1xqAfPt4dm',
    awards: '7hYUrXbhPzeipElb19I7lV',
    newsletter: {
      legal: '1iXTcLW4nUAewdfSzdrFJQ',
      additionalLegal: '7g0eqCtGsdTCpBFMI9CCnc',
      content: '2nw8WKtSTmB3mq2Np60Ang',
    },
  },
  chatWidget: '4BWRr9MRtKmZPZRdoqVYfE',
  pageNotFound: '1zctSjroBMmM0cZfKoQYfx',
  pages: {
    newsletter: {
      teaserTile: '5S1Zsp9LvduYITn82h4y2u',
      legalText: '1iXTcLW4nUAewdfSzdrFJQ',
      redirectSubscribed: '5Sqm1jw7VmoUGCaiWKs4Gw',
      redirectAlreadySubscribed: '52bwodKVfYzobJOyY4YRNF',
    },
    sprayDays: {
      page: 'fxPEk0jbdGT2Gn6X6lRWJ',
      sprayer: '5PCRwPhwPCfCPzfv3jx4J9',
    },
  },
  cart: {
    returnsSidePanel: 'mnaBfWfmrE57LWyzzmVqe',
    shippingSidePanel: 'FaTnaweXXlWwenvI4JZBv',
  },
  customerAccount: {
    faq: '3wzte9lvDTARgPlAmL4K0G',
  },
}
